import { Cct, Client, IjmInfo } from "../__generated__/graphql";
import { IjmSelection } from "./utils";

type IjmCanChangeConfiguration = {
    [key: string]: {
        [workerGroup: string]: boolean;
    };
};

type IjmConfiguration = {
    cctGroups: {
        [key: string]: {
            [workerGroup: string]: IjmInfo;
        };
    };
};

export const canChangeIjm = (client: Client, cct: Cct, workerGroup: string): boolean => {
    const config = client.canChangeIjmConfiguration as IjmCanChangeConfiguration | null | undefined;

    if (!config) {
        return true;
    }

    if (client.useLegalEmployer.useLseCct || cct.cctContractId.startsWith("lift-no-cct")) {
        return config["none"]?.[workerGroup] ?? true;
    }
    return config[cct.cctContractId]?.[workerGroup] ?? true;
};

export const getIjmSelection = (
    client: Client,
    cct: Cct,
    workerGroup: string,
): IjmSelection | undefined => {
    const config = client.ijmConfiguration as IjmConfiguration | null | undefined;
    if (!config) {
        return undefined;
    }
    let workerConfig: IjmInfo | undefined;
    let cctConfig:
        | {
              [workerGroup: string]: IjmInfo;
          }
        | undefined;

    const noCCTConfig = config.cctGroups["none"] ?? undefined;
    if (client.useLegalEmployer.useLseCct || cct.cctContractId.startsWith("lift-no-cct")) {
        cctConfig = noCCTConfig;
    } else {
        cctConfig = config.cctGroups[cct.cctContractId] ?? undefined;
    }

    if (workerGroup !== "all") {
        // in case we want a config for a specific group we will try to find a config and use the no cct config
        // in case no config has been specified for a cct. We also try the all worker if config does not exist
        // for a specific worker group
        if (!cctConfig) {
            workerConfig = noCCTConfig[workerGroup] ?? noCCTConfig["all"] ?? undefined;
        } else {
            workerConfig = cctConfig[workerGroup] ?? cctConfig["all"] ?? undefined;
        }
    } else {
        // in case we do not want a specific group, we return only the existing config for the cct
        workerConfig = cctConfig?.[workerGroup] ?? undefined;
    }

    if (workerConfig) {
        return {
            ijmGroupId: workerConfig.ijmGroup ? workerConfig.ijmGroup.id : null,
            ijmGroupName: workerConfig.ijmGroup ? workerConfig.ijmGroup.name : null,
            ijmPayFirstDays: workerConfig.payFirstDays,
            ijmPayRemainingPercents: workerConfig.payRemainingPercents,
        };
    }
    return undefined;
};
